import { render, staticRenderFns } from "./BtnBack.vue?vue&type=template&id=0596c444&scoped=true&"
import script from "./BtnBack.vue?vue&type=script&lang=js&"
export * from "./BtnBack.vue?vue&type=script&lang=js&"
import style0 from "./BtnBack.vue?vue&type=style&index=0&id=0596c444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0596c444",
  null
  
)

export default component.exports